<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <h1 class="text-title-underline">{{ t('browsing_history.title') }}</h1>
        <template v-if="Array.isArray(videoBrowsings) && videoBrowsings.length">
          <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3">
            <div v-for="videoBrowsing in pagedList" :key="videoBrowsing.id">
              <template v-if="videoBrowsing.video">
                <router-link
                  :to="`/video/${videoBrowsing.video.id}`"
                >
                  <video-thumbnail :video="videoBrowsing.video" />
                </router-link>
              </template>
            </div>
          </div>
          <div class="flex items-center justify-center mt-10">
            <base-pagination v-model:pagedList="pagedList" :originalList="videoBrowsings" :pageSize="pageSize" />
          </div>
        </template>
        <template v-else>
          動画が見つかりませんでした。
        </template>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { VideoBrowsingAttributes } from '@/types/models/video-browsing'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BasePagination from '@/components/BasePagination.vue'
import VideoThumbnail from '@/components/VideoThumbnail.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    BasePagination,
    VideoThumbnail
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const videoBrowsings = computed(() => store.state.video.videoBrowsings)
    const pageSize = ref(10)
    const pagedList = ref<VideoBrowsingAttributes[]>([])

    onMounted(() => {
      store.dispatch('video/fetchVideoBrowsings')
    })

    return {
      t,
      store,
      videoBrowsings,
      pageSize,
      pagedList
    }
  }
})
</script>
